module.exports = __webpack_public_path__ + "assets/icons/ic_delete-429c.svg";